import {Component, HostBinding} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'a3_1-console-ui';
  isDark = false;

  @HostBinding('class')
  get themeMode() {
    return this.isDark ? 'dark-theme' : 'light-theme'
  }

  toggle() {
    this.isDark = !this.isDark;
  }
}
